/**
 * Tipi del wizard signup pubblico. Coerenti con MarketplaceTierTypes
 * dell'app principale (preventivatore-app/src/modules/marketplace/types/).
 *
 * Refactor 2026-05-20: signup unificato tier-aware. Lo wizard accetta tier
 * ∈ {free, base, pro, business} + billing ∈ {monthly, yearly} come Step 0.
 * Se viene da marketing-site con query params ?tier=X&billing=Y, lo Step 0
 * viene skippato (smart skipping).
 */

export type RuoloDichiarato = 'venditore' | 'installatore' | 'entrambi' | 'fornitore';

/** Tier commerciali — single source of truth da preventivatore-app/docs/01-ARCHITECTURE/TIER-CAPABILITY-VISIBILITY-MODEL.md */
export type SignupTier = 'free' | 'base' | 'pro' | 'business';
export type SignupBilling = 'monthly' | 'yearly';

export interface SignupState {
  // Step 0 — Tier scelto (signup unificato 2026-05-20)
  tier?: SignupTier;
  billing_frequency?: SignupBilling;
  /** Se true, lo Step 0 è stato preselezionato via query param e va skippato */
  tier_preselected?: boolean;

  // Step 1 — Ruolo (deprecato, mantenuto per compat)
  ruolo?: RuoloDichiarato;

  // Step 2 — Dati azienda
  ragione_sociale?: string;
  partita_iva?: string;
  sede_via?: string;
  sede_citta?: string;
  sede_cap?: string;
  sede_provincia?: string;
  sede_regione?: string;

  // Step 3 — Profilo admin
  admin_nome?: string;
  admin_cognome?: string;
  admin_email?: string;
  admin_telefono?: string;
  admin_password?: string;

  // Step 4 — GDPR
  accettato_termini?: boolean;
  accettato_privacy?: boolean;
  accettato_marketing?: boolean;
}

export const INITIAL_SIGNUP_STATE: SignupState = {
  tier: 'free',
  billing_frequency: 'monthly',
};

/**
 * Step del wizard signup. Niente più `label`/`tag` hardcoded:
 * il label è tradotto via i18n (`t('stepper.<id>')` nel namespace `signup`).
 *
 * Refactor 2026-05-20: aggiunto step 'tier' come primo (smart-skippato se
 * tier preselezionato da query param `?tier=X`).
 */
export const SIGNUP_STEPS = [
  { id: 'tier' },
  { id: 'azienda' },
  { id: 'profilo' },
  { id: 'termini' },
  { id: 'riepilogo' },
] as const;

export type SignupStepId = (typeof SIGNUP_STEPS)[number]['id'];

/** Pricing canonical — coerente con tier_definitions Firestore */
export const TIER_PRICING: Record<SignupTier, { monthly: number; yearly: number }> = {
  free: { monthly: 0, yearly: 0 },
  base: { monthly: 19, yearly: 190 },
  pro: { monthly: 49, yearly: 490 },
  business: { monthly: 99, yearly: 990 },
};
